import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { PlusdCommonService } from "../../services/plusd-common.service";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatMenuTrigger,
  MatSort,
  MatTableDataSource
} from "@angular/material";
import { timer } from "rxjs";
import { XsMessageBoxComponent } from "../../../common/widgets/xs-message-box/xs-message-box.component";
import * as moment from "moment";
import { XsAppConfigService } from "../../../common/services/xs-app-config.service";

@Component({
  selector: "app-datatable-widget",
  templateUrl: "./datatable-widget.component.html",
  styleUrls: ["./datatable-widget.component.css"]
})
export class DatatableWidgetComponent implements OnInit {
  @Input()
  parametro: any;

  @ViewChild(MatMenuTrigger, { static: true })
  public menuTrigger: MatMenuTrigger;

  @ViewChild(MatSort, { static: true })
  sort: MatSort;

  public menuLeft = 0;
  public menuTop = 0;
  altoTitulo = 0;
  altoFiltro = 0;
  anchoTreeview = 0;
  nodo: any;

  descripcion = "";
  active = null;
  plugInsEnEjecucion = [];
  submodulos = [];
  modulos = [];
  plugins = [];
  menuesDisponibles = [];

  multaSeleccionada: any = null;
  loading: boolean = false;

  parametros: any = { idTipoTramite: "", estado: [] };
  plugin: any = { componente: null };
  columnasDisponiblesDerivada = [];
  columnasVisibles = [];
  columnasDisponibles = [];
  columnasDisponiblesOA = [];
  dataSource: any = null;

  constructor(
    public xsAppConfigService: XsAppConfigService,
    public plusdCommonService: PlusdCommonService,
    public dialog: MatDialog
  ) { }

  ngOnChanges(data) {
    console.log("mostrando cambios", data);
  }

  ngOnInit() {
    this.altoTitulo = parseInt(this.parametro.altoTitulo.replace("px", ""));
    this.altoFiltro = parseInt(this.parametro.altoFiltro.replace("px", ""));
    this.anchoTreeview = parseInt(this.parametro.anchoTreeview.replace("px", ""));
  }

  /*---------------------------------------------------------------------------*/
  /*------------------------------------EVENTOS--------------------------------*/
  /*---------------------------------------------------------------------------*/
  onCLickMenu(key, multaSeleccionada) {
  }

  onTreeNodoSeleccionado(nodo) {
  }

  columnasParaMostrar(columnas) {
    var columnasDisponibles = columnas.filter(c => {
      return c.visible;
    });
    // console.log("columnasDisponibles: ", columnasDisponibles);
    var nombreColsVisibles = columnasDisponibles.map(c => {
      return c.nombre;
    });
    // console.log("nombreColsVisibles: ", nombreColsVisibles);

    return nombreColsVisibles;
  }

  formatearColumna(element, column) {
    switch (column.tipo) {
      case "date":
        return element[column.nombre] ? moment(element[column.nombre]).format("DD/MM/YYYY") : "";
      case "number":
        var x = parseFloat(element[column.nombre]).toFixed(2);
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
      default:
        return element[column.nombre];
    }
  }

  esImportante(element) {
    return element.importante ? "xs-importante" : "xs-no-importante";
  }

  onClickMulta(row) {
    //console.log("CLICK: ", row);
    let now = moment("2018-09-11"); // add this 2 of 4
    // console.log("hello world", now.format("DD/MM/YYYY"));
  }

  onRigthClickMulta(e, row) {
    console.log("mostrando evento onRigthClickMulta", e, "  -  ", row);
    this.multaSeleccionada = row;

    this.asignarMenues(row);

    event.preventDefault();
    this.menuLeft = e.layerX + this.anchoTreeview;
    this.menuTop = e.layerY + this.altoTitulo + this.altoFiltro;
    this.menuTrigger.openMenu();
  }

  asignarMenues(row) {
    // var nroResolucionCorto = "";
    // if (row.idEstadoTramite != "B") {
    //   nroResolucionCorto = row.nroResolucion ? row.nroResolucion.substring(0, row.nroResolucion.indexOf("/")) : null;
    // }

    if (this.parametro.tipo != "OFICINA_ADM") {
      this.menuesDisponibles = [
        { key: "ON_ABRIR_RESOLUCION", nombre: "Abrir Resolución", divider: false }
        // { key: "ON_VER_TRAZABILIDAD", nombre: "Ver Trazabilidad", divider: false }
      ];
    }

    // if (this.parametro.tipo == "OFICINA_ADM") {
    //   this.menuesDisponibles = [
    //     { key: "ON_AGREGAR_MEMO", nombre: "Agregar Memo", divider: false },
    //     { key: "ON_MODIFICAR_MEMO", nombre: "Modificar Memo", divider: false },
    //     { key: "ON_ELIMINAR_MEMO", nombre: "Eliminar Memo", divider: false }
    //   ];
    // }
  }

  onClickRegistrarImportante(e) {
    console.log("mostrando dato de fila", e);
    if (e.importante == "0" || e.importante == null) {
      this.parametros.importante = "1";
    } else {
      this.parametros.importante = "0";
    }
    this.parametros.idTramite = e.idTramite;
    this.parametros.audModificadoPor = "wcabrera";
  }

  onMouseOver(e) {
    // console.log(
    //   "TLfet: ",
    //   this.tableLeft,
    //   "TTop: ",
    //   this.tableTop,
    //   "clientX: ",
    //   e.clientX,
    //   "clientY: ",
    //   e.clientY,
    //   "CX-TLeft: ",
    //   e.clientX - this.tableLeft,
    //   "CY-TTop: ",
    //   e.clientY - this.tableTop
    // );
  }

  classHeaderColumna(columna) {
    // switch (columna.nombre) {
    //   return "";
    // }

    return "xs-header-cell";
  }

  classColumna(columna, tramite) {
    var clase = {};

    switch (columna.tipo) {
      case "number":
      case "number":
      case "date":
        clase = { "xs-rigth-alignment": true };
        break;
      default:
        clase = { "xs-left-alignment": true };
    }


    var dias = tramite.diasTranscurrDesdeNotif;
    switch (columna.nombre) {
      case "diasTranscurrDesdeNotif":
        if (tramite.idTipoTramite != "EC") {
          clase["diasTranscurrDesdeNotif-verde"] = dias >= 1 && dias <= 5;
          clase["diasTranscurrDesdeNotif-amarillo"] = dias >= 6 && dias <= 10;
          clase["diasTranscurrDesdeNotif-naranja"] = dias >= 11 && dias <= 15;
          clase["diasTranscurrDesdeNotif-rojo"] = dias >= 16;
        }
        if (tramite.idTipoTramite == "EC") {
          clase["diasTranscurrDesdeNotif-verde"] = dias >= 1 && dias <= 2;
          clase["diasTranscurrDesdeNotif-amarillo"] = dias >= 3 && dias <= 6;
          clase["diasTranscurrDesdeNotif-rojo"] = dias >= 7;
        }
        break;
    }

    return clase;
  }

}
